module.exports = __webpack_public_path__ + "img/gdzie_nas_znalezc.a87f936c.jpg";